import { Timestamp, getFirestore, doc, setDoc } from "firebase/firestore";
import { Collection } from "firestorter";

import GeneralStore from "../general/store";
import Administration from "./administration";

export { default as Administration } from "./administration";
export * from "./administration";
export { default as Sync } from "./sync";
export { default as Employee } from "./employee";
export type { EmployeeData } from "./employee";
export { default as Invitation } from "./invitation";
export type { InvitationStatus, InvitationData } from "./invitation";
export { default as Product } from "./product";
export type { ProductData } from "./product";
export { default as Customer } from "./customer";
export type { CustomerData } from "./customer";
export { default as Vehicle } from "./vehicle";
export type { VehicleData } from "./vehicle";
export { default as Location } from "./location";
export type { LocationData } from "./location";
export { default as HourType } from "./hourtype";
export type { HourTypeData } from "./hourtype";
export { default as WorkOrder } from "./workorder";
export * from "./workorder";

export interface AddAdministrationData {
  code: string;
}

class MultiversStore extends GeneralStore {
  administrations = new Collection("multivers", {
    createDocument: (source, options) =>
      new Administration(source, options, this.store),
  });

  administration(code: string) {
    return new Administration(`multivers/${code}`, {}, this.store);
  }

  addAdministration = async (data: AddAdministrationData) => {
    const { code } = data;

    const administration = {
      createdAt: Timestamp.now(),
      createdBy: this.store.auth.user?.id,
    };
    const firestore = getFirestore();
    await setDoc(doc(firestore, `multivers${code}`), administration);
  };
}

export default MultiversStore;
